import * as S from './styles';

const NavbarDivider = () => {
	return <S.Base />;
};

export default NavbarDivider;
